import { store } from "@betacrew/jars-flux";
import { all, put, select, takeLatest } from "redux-saga/effects";
import { componentKey, setLoadingState } from "./ChangeScheduleDateModalSlice";
import { PAGE_STATE } from "../../../constants/constants";
import SubmitFormsDataService from "../../../../../services/SubmitFormsDataService";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import { setChangeScheduleDateForAllVendor, setShouldGetSubmittedFormsGridData } from "../FormListingSlice";
import DateUtils from "../../../../../libs/utility/DateUtils";
import Forms from "../../../../../libs/utility/formsutility/Forms";
import { getSubmittedForms } from "../FormListingSaga";

export const { changeScheduleDateForAllVendor } = {
    changeScheduleDateForAllVendor: (payload) => {
        return {
            type: "CHANGE_SCHEDULE_DATE_FOR_ALL_VENDOR",
            payload
        }
    },
}

function* changeScheduleDateForAllVendorAsync(action) {
    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Loading..." }))

        const { payerId, taxYearId, formId, status, ReadyToSubmitForms, scheduleDate } = action?.payload;

        const data = {
            payerId: payerId,
            taxYear: taxYearId,
            formId: formId,
            status: "Not Submitted",
            scheduleDate: DateUtils.dateFormatter(scheduleDate, "MM/DD/YYYY"),
            scheduleDate2: "",
            formName: formId,
            FormType: "",
            statustype: status,
            jsonPreferences: Forms.getJsonPreferences(ReadyToSubmitForms, ReadyToSubmitForms)
        }

        const response = yield SubmitFormsDataService.changeScheduleDataForAllVendor(data);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(addNotifications({ heading: "All vendors schedule dates have been successfully changed.", variant: TOASTER_VARIANT.SUCCESS }));
            yield put(setChangeScheduleDateForAllVendor(false))
            yield put(setShouldGetSubmittedFormsGridData({
                gridData: true,
                updatePagination: false,
            }))
        } else {
            yield put(addNotifications({ heading: "Failed to change schedule dates.", message: Message, }));
            yield put(setChangeScheduleDateForAllVendor(false))
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to change schedule dates.", message: error?.response?.data?.Message }));
        yield put(setChangeScheduleDateForAllVendor(false))
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(changeScheduleDateForAllVendor().type, changeScheduleDateForAllVendorAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);